import { BaseColumnEntry, ColumnSettings } from './types'

const getShownColumns = <
  T extends string,
  U extends BaseColumnEntry<T>,
  BulkToggleKey extends string,
  OrderOptionKey extends string,
>({
  enabledColumnIds,
  columns,
}: ColumnSettings<T, U, BulkToggleKey, OrderOptionKey>) =>
  enabledColumnIds.flatMap((id) => {
    const column = columns.find((column) => column.id === id)
    return column ? [column] : []
  })

export default getShownColumns
